import { CONTENT_SECTIONS } from '../../../content/sections';
import { Offer, Placeholder } from '../../../../../types/__codegen__/sanity/graphql';

type OfferContentProps = {
  overrideOffers?: Offer[];
  placeholders?: Placeholder[];
  targetSegment?: string;
} | null;

const mapOfferContent = (offerContentToRender: OfferContentProps) => ({
  ...offerContentToRender,
  orderIndex: 0,
  type: CONTENT_SECTIONS.OFFER,
  variant: 'inHero' as const,
});

export default mapOfferContent;
